import { FormGroup, Label, Input } from "reactstrap";
import { useEffect, useState } from "react";

const ValidateSelectField = ({
  input,
  label,
  isRequired,
  values,
  meta: { touched, error, warning },
  placeholder,
  disabled,
  defaultValue,
}: any) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const toggle = () => setTooltipOpen(!tooltipOpen);

  useEffect(() => {
    if (defaultValue) {
      input.onChange(defaultValue && defaultValue.value);
    }
  }, [defaultValue && defaultValue, input.value, input.onChange]);
  return (
    <FormGroup>
      <FormGroup className="select-option row mb-3">
        <Label className="selectlabel">
          {label}
          {isRequired && <span className="input-required">*</span>}
        </Label>
        <Input
          type="select"
          {...input}
          name="select"
          id="state"
          onChange={(e: { target: { value: any } }) =>
            input.onChange(e.target.value)
          }
          disabled={disabled}
          placeholder={placeholder}
          defaultValue={defaultValue}
        >
          {!input.value ? (
            <option key="select" value="">
              {""}
            </option>
          ) : (
            <option key="select" value="">
              {""}
            </option>
          )}
          {values.map((option: any) => (
            <option key={option.value} value={option.value}>
              {option.text.length > 30
                ? option.text.substring(0, 30) + "..."
                : option.text}
            </option>
          ))}
        </Input>
        {error && input.value === "" ? (
          <h6 className="select-field danger">{error}</h6>
        ) : (
          ""
        )}
        {warning && input.value === "" ? (
          <h6 className="select-field danger">{warning}</h6>
        ) : (
          ""
        )}
      </FormGroup>
    </FormGroup>
  );
};
export default ValidateSelectField;
